import { render, staticRenderFns } from "./dynamicDiscountBlock.vue?vue&type=template&id=d123f640&scoped=true&"
import script from "./dynamicDiscountBlock.vue?vue&type=script&lang=js&"
export * from "./dynamicDiscountBlock.vue?vue&type=script&lang=js&"
import style0 from "./dynamicDiscountBlock.vue?vue&type=style&index=0&id=d123f640&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d123f640",
  null
  
)

export default component.exports